export default __webpack_public_path__ + "static/media/mg-3-rMAX.28ef5b9d.avif";